import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { infoToast, successToast } from "../../Utils/utils";
import { ab, endTime, logTimeChange, startTime, stopTimerRunning, times, totalTime } from "../Exam";
import { showResults } from "../Results/Results";
import { showSelfRating } from "../SelfRating/SelfRating";
import { saveDr } from "./SaveDr";
import { saveFt } from "./SaveFt";
import { saveIf } from "./SaveIf";
import { saveLa } from "./SaveLa";
import { saveMc } from "./SaveMc";
import { saveOr } from "./SaveOr";
import { saveSc } from "./SaveSc";
import { saveSf } from "./SaveSf";
import { addTimes, calcTotalTime, toShowTimeAnalysis } from "./SaveTimes";

export var answers = {}; // Object with structure: taskId => {inputId => {}, inputId => {}}
export var savedTimes = {};

export interface taskTime {
    expected: number;
    time: number;
}

export interface times {
    tasks: {number: taskTime};
    expected_time: number;
    time_left: number;
    used_time: number;
}

export interface inputResult {
    answer: string | number | Array<number>;
    correct: string | number;
    points: number;
    possible: number;
    right: number;
    info?: string;
    identifier?: string;
}

export interface taskResult {
    inputs: Object;
    points: number;
    possible: number;
}

export interface answers {
    tasks: {number: taskResult}
    points: number;
    possible: number;
}

export interface results {
    times?: times;
    answers: answers;
    self?: boolean;
    selfToDo: Array<number>;
    test_nr: number;
}

/**
 * Submit Ab
 */
 export function submitAb(btn:JQuery){
    getAnswers();
    stopTimerRunning();

    const abId = getAbId();

    const url = '/test/' + abId.toString() + '/submit'

    const data = {
        answers: answers
    }

    if (toShowTimeAnalysis()){
        logTimeChange();
        data.times = times;
        data.used_time = calcTotalTime(startTime);
    }

    const success = function (data){
        if (data.self){
            infoToast("Bitte bewerte deinen übrigen Eingaben", "Abgabe gespeichert", 4500, true);
            savedTimes = data.results.times;
            showSelfRating(data.selfToDo, data.results.answers, data.results.id);
        } else {
            successToast("Deine Abgabe wurde ausgewertet", "Erfolg", 4500, true);
            console.log(data)
            showResults(data.results.answers, data.results.times, data.show_grade, data.show_time_analysis, data.results.created_at);
        }
    }

    return ajaxRequest(url, success, data, btn);

}


function getAnswers(){
    const tabs = $(".tab");
    answers = {}
    tabs.each((ind, tab) => {
        workTab(ind, tab);
    })
    return answers;
}

function getAbId(){
    return $(ab).attr('data-id');
}

function workTab(ind:number, tab:HTMLElement){
    const taskId = parseInt($(tab).attr('data-aufgabe'));
    answers[taskId] = {};

    const inputs = $(tab).find(".input");
    inputs.each((ind, input) => {
        workInput(ind, input, taskId);
    })
}

function workInput(ind:number, input:HTMLElement, taskId:number){
    const inputId = parseInt($(input).attr('data-id'));
    const type = $(input).attr('data-type');
    answers[taskId][inputId] = {answer: ''}

    switch(type){
        case "if":
            answers[taskId][inputId] = saveIf(taskId, inputId, input)
            break;
        case "mc":
            answers[taskId][inputId] = saveMc(taskId, inputId, input);
            break;
        case "sc":
            answers[taskId][inputId] = saveSc(taskId, inputId, input);
            break;
        case "sf":
            answers[taskId][inputId] = saveSf(taskId, inputId, input);
            break;
        case "ft":
            answers[taskId][inputId] = saveFt(taskId, inputId, input);
            break;
        case "la":
            answers[taskId][inputId] = saveLa(taskId, inputId, input);
            break;
        case "dr":
            answers[taskId][inputId] = saveDr(taskId, inputId, input);
            break;
        case "or":
            answers[taskId][inputId] = saveOr(taskId, inputId, input);
            break;
    }
}